<template>
  <div class="directory-box">
    <div class="main-content">
      <div class="head-panel visibility">
        <div class="title">Вывоз мусора</div>
        <router-link to="/directories/garbage-removal-categories/new">
          <div class="add-table-string"><i>+</i>Добавить строку</div>
        </router-link>
      </div>
      <table cellpadding="0" cellspacing="0">
        <thead>
        <tr>
          <td>Наименование категории</td>
          <td>Стоимость суток, руб.</td>
          <td>Стоимость доп. суток, руб.</td>
          <td>Зар. плата, руб.</td>
          <td>Зар. плата за доп. сутки, руб.</td>
        </tr>
        </thead>
        <tbody>
        <tr title="Изменить" v-for="category in garbageRemovalCategories" @value="category"
            @key="category.id" @click="openGarbageRemovalCategory(category.id)" v-if="!category.removed">
          <td class="name"> {{ category.name }}</td>
          <td>{{ category.price }}</td>
          <td>{{ category.addPrice }}</td>
          <td>{{ category.salary }}</td>
          <td>{{ category.addSalary }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'GarbageRemovalCategories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      garbageRemovalCategories: []
    }
  },

  mounted () {
    api
      .getGarbageRemovalCategories()
      .then(garbageRemovalCategories => {
        if (garbageRemovalCategories) {
          this.garbageRemovalCategories = []
          this.garbageRemovalCategories = garbageRemovalCategories
        }
      })
  },

  methods: {
    openGarbageRemovalCategory (id) {
      this.$router.push({ name: 'GarbageRemovalCategory', params: { id: id } })
    }
  }
}
</script>
